
import { Helper } from 'dxf';

import Events from '../Events';
import FileTypes from '../FileTypes';
import BaseController from './BaseController';

import EMFPath from '../EMFPath';
import EMFMesh from '../gh/geometry/EMFMesh';

import DxfGroup from '../dxf/DxfGroup';
import DxfPolyline from '../dxf/DxfPolyline';

const unit = 0.001;
const thickness = 24;
// const unit = 1

export default class DXFController extends BaseController {
  constructor (baseUrl, canvas, theme, options) {
    super(baseUrl, canvas, theme, options);
    this.groups = [];
  }

  get fileType () {
    return FileTypes.DXF;
  }

  setupScene (canvas) {
    super.setupScene(canvas);
  }

  destroy () {
    super.destroy();
  }

  reset () {
    super.reset();
  }

  get sliders () {
    return [];
  }

  get toggles () {
    return [];
  }

  get valueLists () {
    return [];
  }

  get exportComponents () {
    // let groups = this.groups.filter((group) => group.root.vertices.length < 120)
    // return groups.map((group, idx) => {

    let thickness = this.materialThickness;

    return this.groups.map((group) => {
      let path = new EMFPath('', '', 1);
      path.setExPath(group.root.vertices.map((v) => { return { x: v[0], y: v[1] }; }));
      group.children.forEach((child) => {
        path.addInPath(child.vertices.map((v) => { return { x: v[0], y: v[1] }; }));
      });
      path.thickness = thickness;
      return {
        paths: [ path ]
      };
    });
  }

  update (ui) {
  }

  centerize (meshes) {
  }

  addSide (geometry, path, extrusion) {
    let offset = geometry.vertices.length;
    path.slice().forEach((v) => {
      geometry.vertices.push(v);
      geometry.vertices.push(v.clone().add(extrusion));
    });
    for (let i = 0, n = path.length * 2; i < n; i += 2) {
      let lb = i + offset;
      let lu = (i + 1) + offset;
      let rb = (i + 2) % n + offset;
      let ru = (i + 3) % n + offset;
      geometry.faces.push(new THREE.Face3(lb, lu, rb));
      geometry.faces.push(new THREE.Face3(ru, rb, lu));
    }
    return geometry;
  }

  extrude (group) {
    let contour = group.root.vertices.map((v) => new THREE.Vector3(v[0], v[1], 0));
    let holes = group.children.map((child) => {
      return child.vertices.map((v) => new THREE.Vector3(v[0], v[1], 0));
    });

    if (!THREE.ShapeUtils.isClockWise(contour)) {
      contour = contour.reverse();
    }

    holes = holes.map((hole) => {
      if (!THREE.ShapeUtils.isClockWise(hole)) {
        return hole.reverse();
      }
      return hole;
    });

    let triangles = THREE.ShapeUtils.triangulateShape(contour, holes);
    let geometry = new THREE.Geometry();
    let vertices = contour.slice();
    holes.forEach((hole) => {
      vertices = vertices.concat(hole);
    });
    let length = vertices.length;

    // up
    let extrusion = new THREE.Vector3(0, 0, thickness);
    geometry.vertices = vertices;
    vertices.forEach((v) => {
      let up = v.clone().add(extrusion);
      geometry.vertices.push(up);
    });

    // bottom
    geometry.faces = triangles.map((tri) => {
      return new THREE.Face3(tri[0], tri[2], tri[1]);
    });
    // up
    triangles.forEach((tri) => {
      geometry.faces.push(new THREE.Face3(tri[0] + length, tri[1] + length, tri[2] + length));
    });

    // side
    this.addSide(geometry, contour, extrusion);
    holes.forEach((hole) => {
      this.addSide(geometry, hole.reverse(), extrusion);
    });

    geometry.computeFaceNormals();

    // return new THREE.Mesh(geometry, new THREE.MeshNormalMaterial({}))
    return new EMFMesh(geometry);

    /*
    // check grouping by lines

    let object = new THREE.Group()

    let geom = new THREE.Geometry()
    geom.vertices = contour
    object.add(new THREE.Line(geom, new THREE.LineBasicMaterial({ color: 0xff0000 })))

    holes.forEach((hole) => {
      let hgeom = new THREE.Geometry()
      hgeom.vertices = hole
      object.add(new THREE.Line(hgeom, new THREE.LineBasicMaterial({ color: 0x0033ff })))
    })

    return object
    */
  }

  addMesh (mesh) {
    this.setupMesh(mesh);
    this.addIndirect(mesh);
  }

  addIndirect (mesh) {
    mesh.rotation.set(-Math.PI * 0.5, 0, 0);
    mesh.position.set(0, 1e-6, 0);
    mesh.scale.set(unit, unit, unit);
    this.container.add(mesh);
  }

  group (polylines) {
    let groups = [];

    // insert head
    groups.push(new DxfGroup(polylines.shift(0)));

    for (let i = 0, n = polylines.length; i < n; i++) {
      let poly = polylines[i];

      let inserted = false;
      for (let j = 0, m = groups.length; j < m; j++) {
        let grp = groups[j];
        inserted = grp.contains(poly);
        if (inserted) {
          grp.add(poly);
          break;
        }
      }

      if (!inserted) {
        let replaced = false;

        for (let j = 0, m = groups.length; j < m; j++) {
          let grp = groups[j];
          replaced = poly.containsPolyline(grp.root);
          if (replaced) {
            grp.replace(poly);
            break;
          }
        }

        // CAUTION:
        // Not tolerate nested over than 3 times group

        if (!replaced) {
          groups.push(new DxfGroup(poly));
        }
      }
    }

    return groups;
  }

  parse (text, report = true) {
    this.reset();

    const helper = new Helper(text);
    let polylines = [];

    let result = helper.toPolylines();
    result.polylines.forEach((polyline) => {
      if (polyline.vertices.length <= 2) {
        return;
      }
      polylines.push(new DxfPolyline(polyline.vertices));

      // console.log(polyline)

      // let vertices = polyline.vertices.map((v) => new THREE.Vector3(v[0], v[1], 0))

      /*
      let geom = new THREE.Geometry()
      geom.vertices = vertices
      let mesh = new THREE.Line(geom, new THREE.LineBasicMaterial({
        color: 0xff0000
      }))
      this.addIndirect(mesh)
      */
    });

    this.groups = this.group(polylines);
    let meshes = this.groups.map(grp => {
      return this.extrude(grp);
    });
    meshes.forEach(mesh => this.addMesh(mesh));

    this.boundingBox.update(this.container);
    this.updateGrid();
  }

  load (path, report, onLoad, onProgress, onError) {
    const loader = new THREE.FileLoader();
    loader.load(
      path,
      (text) => {
        this.parse(text, report);
        if (onLoad !== undefined) {
          onLoad(this);
        }
      },
      onProgress, onError
    );
  }

  setupMesh (mesh) {
    mesh.setMaterial(this.materialType);
    mesh.setTextures(Object.values(this.textures)[0]);
    mesh.castShadow = true;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/controllers/DXFController.js